module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card"
  }) : _c('section', {
    staticClass: "c-card c-card--tier"
  }, [_c('div', {
    staticClass: "c-card--tier__left c-card--tier__summary"
  }, [(_vm.card.level && _vm.card.level.image) ? _c('img', {
    staticClass: "c-card--tier__summary__img qa-tier-image",
    attrs: {
      "src": _vm.card.level.image.url
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-card--tier__summary__text"
  }, [(_vm.card.title) ? _c('h2', {
    staticClass: "c-card--tier__summary__text__title t-tier-title qa-tier-title"
  }, [_vm._v("\n          " + _vm._s(_vm.card.title) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "c-card--tier__summary__text__sub qa-tier-level",
    style: (_vm.levelColor)
  }, [_vm._v("\n          " + _vm._s(_vm.card.level ? _vm.card.level.name : '') + "\n        ")])])]), _vm._v(" "), (_vm.card.level) ? _c('div', {
    staticClass: "c-card--tier__right"
  }, [(_vm.card.level.is_top_tier) ? _c('div', {
    staticClass: "c-card--tier__top-tier-details"
  }, [_c('div', {
    staticClass: "c-card---tier__top-tier-details__text"
  }, [_c('div', {
    staticClass: "c-card---tier__top-tier-details__text__message qa-tier-message",
    domProps: {
      "innerHTML": _vm._s(_vm.card.level.message)
    }
  }), _vm._v(" "), (_vm.card.level.link) ? _c('a', {
    staticClass: "c-card---tier__top-tier-details__link u-no-wrap qa-tier-link js-handle-link",
    attrs: {
      "href": _vm.card.level.link.url
    }
  }, [_vm._v("\n            " + _vm._s(_vm.card.level.link.text) + "\n            »\n          ")]) : _vm._e()])]) : _c('div', [_c('div', {
    staticClass: "c-card--tier__progress-wrapper"
  }, [(_vm.progressValues) ? _c('h4', {
    staticClass: "c-card--tier__progress-wrapper__left\n                      c-card--tier__progress-value \n                      t-tier-progress-text\n                      qa-tier-progress",
    style: (_vm.levelColor)
  }, [_vm._v("\n            " + _vm._s(_vm.progressValues) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-card--tier__progress-bar"
  }, [_c('div', {
    staticClass: "c-card--tier__progress-bar__progress t-tier-progress-bar",
    style: (_vm.progressBarStyle)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-card---tier__details__text"
  }, [_c('span', {
    staticClass: "c-card---tier__details__text__message qa-tier-message",
    domProps: {
      "innerHTML": _vm._s(_vm.card.level.message)
    }
  }), _vm._v(" "), (_vm.card.level.link) ? _c('a', {
    staticClass: "c-card---tier__details__text__link u-no-wrap qa-tier-link js-handle-link",
    attrs: {
      "href": _vm.card.level.link.url
    }
  }, [_vm._v("\n            " + _vm._s(_vm.card.level.link.text) + "\n            »\n          ")]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c9e3d27"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/cards/Tier.vue
// module id = 550
// module chunks = 1